<template>
  <div>
    <van-tabbar v-model="active" route>
        <van-tabbar-item replace to="/index">
            <template #icon="props">
                <img :src="props.active ? icon.active : icon.inactive" />
            </template>
        </van-tabbar-item>
        <!-- <van-tabbar-item replace to="/">
            <template #icon="props">
                <img :src="props.active ? icon.active2 : icon.inactive2" />
            </template>
        </van-tabbar-item> -->
        <van-tabbar-item replace to="/course?id=-1">
            <template #icon="props">
                <img :src="props.active ? icon.active1 : icon.inactive1" />
            </template>
        </van-tabbar-item>
        <!-- <van-tabbar-item replace to="/publics">
            <template #icon="props">
                <img :src="props.active ? icon.active2 : icon.inactive2" />
            </template>
        </van-tabbar-item> -->
        <van-tabbar-item replace to="/myindex">
            <template #icon="props">
                <img :src="props.active ? icon.active3 : icon.inactive3" />
            </template>
        </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import {} from "@/api/home";
import { Toast } from "vant";
export default {
  data() {
    return {
      active: 0,
      icon: {
        active: require('../../assets/img/shou.png'),
        inactive: require('../../assets/img/shouw.png'),
        active1: require('../../assets/img/ky.png'),
        inactive1: require('../../assets/img/kw.png'),
        active2: require('../../assets/img/zb.png'),
        inactive2: require('../../assets/img/zbw.png'),
        // active2: require('../../assets/img/gy.png'),
        // inactive2: require('../../assets/img/gw.png'),
        active3: require('../../assets/img/wy.png'),
        inactive3: require('../../assets/img/ww.png'),
      },
    };
  },
  watch: {},
  components: {},
  methods: {

  },
  mounted() {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/index/di.vue